document.addEventListener('DOMContentLoaded', function () {
    const swipers = document.querySelectorAll('.swiper');

    swipers.forEach(function (swiperContainer) {
        const slidesGap = parseInt(swiperContainer.getAttribute('data-slides-gap'), 10);
        const imagesPerView = parseInt(swiperContainer.getAttribute('data-images-per-view'), 10);
        const autoPlay = swiperContainer.getAttribute('data-autoplay') === 'true';
        const transitionEffect = swiperContainer.getAttribute('data-transition-effect');
        const autoPlayDelay = autoPlay ? parseInt(swiperContainer.getAttribute('data-autoplay-delay'), 10) : undefined;
        const enabledResponsive = swiperContainer.getAttribute('data-responsive') === 'true';
        const mobileBreakpoint = parseInt(swiperContainer.getAttribute('data-mobile-breakpoint'), 10);
        const tabletBreakpoint = parseInt(swiperContainer.getAttribute('data-tablet-breakpoint'), 10);
        const mobileImagesPerView = parseInt(swiperContainer.getAttribute('data-mobile-slides-per-view'), 10);
        const tabletImagesPerView = parseInt(swiperContainer.getAttribute('data-tablet-slides-per-view'), 10);

        var breakpoints = {};

        if (enabledResponsive) {
            breakpoints[mobileBreakpoint] = {
                slidesPerView: tabletImagesPerView,
                // spaceBetween: 50,
            };
            breakpoints[tabletBreakpoint] = {
                slidesPerView: imagesPerView,
                // spaceBetween: 50,
            };
        }

        const swiper = new Swiper(swiperContainer, {
            spaceBetween: slidesGap,
            slidesPerView: enabledResponsive ? mobileImagesPerView : imagesPerView,
            breakpoints,
            loop: true,
            lazy: true,
            autoplay: autoPlay ? {
                delay: autoPlayDelay,
                disableOnInteraction: false,
            } : false,
            effect: transitionEffect != "normal" ? transitionEffect : '',
            pagination: {
                el: '.custom-swiper-pagination',
                clickable: true,
                renderBullet: function (index, className) {
                    return '<span class="' + className + '"></span>';
                },
            },
            navigation: {
                nextEl: '.custom-next-button',
                prevEl: '.custom-prev-button'
            },
        });
    });
});
